import { TicketQrCodeLogo } from '../../assets/images.js';
import { FooterLogo } from '../../assets/images.js';
import { H5, H4, H6, Body3 } from '../../themes/typography';
import '../../styles/components/PurchaseTicket.css';

export default function PurchaseTicket() {

    return (
        <main className="main-ticket-purchase">
            <div className='purchased-ticket-main-container'>

                <div className='purchased-ticket-layout-container'>

                    <section className="ticket-buyer-details-section">

                        <div className="ticket-name-container">
                            <H4 color="var(--secondary-color)" fontWeight={700}>
                                The Summer Music Festival
                            </H4>
                        </div>

                        <div className="attendee-name-label-container">
                            <div className="attendee-label">
                                <H5 color="var(--secondary-color)" fontWeight={500}>
                                    Attendee:
                                </H5>
                            </div>

                            <div className="attendees-name-container">
                                <H6>
                                    Johnathan Alexander Doe
                                </H6>
                            </div>
                        </div>

                        <div className="event-location-details">
                            <div className="attendee-label">
                                <H5 color="var(--secondary-color)" fontWeight={500}>
                                    Location:
                                </H5>
                            </div>

                            <div className="event-location-link">
                                <H6>
                                    The Grand Arena, 123 Main St, Cityville, Country
                                </H6>
                            </div>
                        </div>

                        <div className="attendee-name-label-container">
                            <div className="attendee-label">
                                <H5 color="var(--secondary-color)" fontWeight={500}>
                                    Ticket Type:
                                </H5>
                            </div>

                            <div className="attendees-name-container">
                                <H6>
                                    VIP Access
                                </H6>
                            </div>
                        </div>

                        <div className="attendee-name-label-container">
                            <div className="attendee-label">
                                <H5 color="var(--secondary-color)" fontWeight={500}>
                                    Organizer:
                                </H5>
                            </div>

                            <div className="attendees-name-container">
                                <H6>
                                    Event Masters Inc.
                                </H6>
                            </div>
                        </div>

                        <div className="attendee-name-label-container">
                            <div className="attendee-label">
                                <H5 color="var(--secondary-color)" fontWeight={500}>
                                    Ticket Id:
                                </H5>
                            </div>

                            <div className="attendees-name-container">
                                <H6>
                                    TK4124521
                                </H6>
                            </div>
                        </div>

                        <div className="ticket-qr-code-container">
                            <div className="ticket-qr-code-image">
                                <img src={TicketQrCodeLogo} alt="Ticket QR Code" />
                            </div>

                            {/* {data?.qr_code && (
                                <div className="ticket-qr-code-logo">
                                    <img src={TicketQrCodeLogo} alt="Shmooz" />
                                </div>
                            )} */}
                        </div>

                    </section>

                    <section className="ticket-shape">
                        <div className="ticket-divider"></div>
                    </section>

                    <section className="ticket-schedule-details-section">

                        <div className="various-ticket-schedule-container">

                            <H5 color="var(--secondary-color)" fontWeight={500}>
                                Ticket valid for:
                            </H5>

                            <div className='ticket-valid-for-schedule-container'>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Mon, 01 Jan 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Tue, 02 Feb 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Wed, 03 Mar 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Thu, 04 Apr 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Fri, 05 May 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Sat, 06 Jun 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Sun, 07 Jul 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Mon, 08 Aug 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Tue, 09 Sep 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Sun, 07 Jul 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Mon, 08 Aug 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                                <div className="valid-schedule-box-container">
                                    <div className="valid-schedule-date-container">
                                        <Body3 fontWeight={400}>
                                            Tue, 09 Sep 2024
                                        </Body3>
                                    </div>
                                    <div className="valid-schedule-timing-container">
                                        <Body3>
                                            11:00 - 22:00
                                        </Body3>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="platform-logo-container">
                            <div className="platform-logo-inner-container">
                                <img src={FooterLogo} alt="Shmmoz" />
                            </div>
                        </div>

                    </section>
                </div>
            </div>
        </main>
    );
}
